import { render } from "./Cookies.vue?vue&type=template&id=3b58b3d0"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__